import {createProductStore, Store} from "@/app/lib/pricing/paddle-store";

const paddleProdStore: Store = createProductStore({
    testMode: false,
    productId: 'pro_01jaznbxgv6yfsj5e00yardzhs',
    foundationMonthlyPriceId: 'pri_01jaznfk5b7awk03njmsjdrp5d',
    foundationPlusMonthlyPriceId: 'pri_01jaznk375rdd1rn0ehvzw32qn',
    foundationYearlyPriceId: 'pri_01jazngq9tkarg5zy25dfzh549',
    foundationPlusYearlyPriceId: 'pri_01jaznkx6q4j47zyj4ntxsh709',
    proMonthlyPriceId: 'pri_01jaznhhqbv5jkxh334r0x9smz',
    proPlusMonthlyPriceId: 'pri_01jaznnrb4hw9bhnwwrjh9a218',
    proYearlyPriceId: 'pri_01jaznjb0pq270269a5sn8w5tk',
    proPlusYearlyPriceId: 'pri_01jaznpvy7jr0rmnprjrfdcct9',
});

export default paddleProdStore;
